import { render, staticRenderFns } from "./BaseTopCards.vue?vue&type=template&id=5d96d344&scoped=true&"
import script from "./BaseTopCards.vue?vue&type=script&lang=js&"
export * from "./BaseTopCards.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5d96d344",
  null
  
)

export default component.exports